import { type IIcon } from '@/app/types/iconType'

export const Trash = (props: Omit<IIcon, 'iconName'>) => {
    const { height = '40', width = '40', color = '#FC3969' } = props
    return (
        <svg width={width} height={height} viewBox='0 0 40 40' fill='none' xmlns='http://www.w3.org/2000/svg'>
            <path
                d='M18.5 18.5C18.9142 18.5 19.25 18.8358 19.25 19.25V23C19.25 23.4142 18.9142 23.75 18.5 23.75C18.0858 23.75 17.75 23.4142 17.75 23V19.25C17.75 18.8358 18.0858 18.5 18.5 18.5Z'
                fill={color}
            />
            <path
                d='M22.25 19.25C22.25 18.8358 21.9142 18.5 21.5 18.5C21.0858 18.5 20.75 18.8358 20.75 19.25V23C20.75 23.4142 21.0858 23.75 21.5 23.75C21.9142 23.75 22.25 23.4142 22.25 23V19.25Z'
                fill={color}
            />
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M16.7812 15.3235C16.8033 14.7822 17.028 14.2677 17.4126 13.8832C17.818 13.4778 18.3678 13.25 18.9412 13.25H21.1029C21.6763 13.25 22.2261 13.4778 22.6315 13.8832C23.0161 14.2677 23.2408 14.7822 23.2629 15.3235H26.0441C26.4583 15.3235 26.7941 15.6593 26.7941 16.0735C26.7941 16.4877 26.4583 16.8235 26.0441 16.8235H25.3823V23.75C25.3823 25.4069 24.0392 26.75 22.3823 26.75H17.7263C16.0828 26.75 14.7437 25.4292 14.7271 23.7836C14.7053 21.6252 14.6743 18.4384 14.6647 16.8235H14C13.5858 16.8235 13.25 16.4877 13.25 16.0735C13.25 15.6593 13.5858 15.3235 14 15.3235H16.7812ZM18.4732 14.9438C18.5973 14.8197 18.7656 14.75 18.9412 14.75H21.1029C21.2784 14.75 21.4468 14.8197 21.5709 14.9438C21.674 15.0469 21.7395 15.1806 21.7588 15.3235H18.2853C18.3045 15.1806 18.3701 15.0469 18.4732 14.9438ZM23.8823 16.8235V23.75C23.8823 24.5784 23.2108 25.25 22.3823 25.25H17.7263C16.9031 25.25 16.2353 24.5893 16.227 23.7684C16.2052 21.6076 16.1743 18.4319 16.1647 16.8235H23.8823Z'
                fill={color}
            />
        </svg>
    )
}
